import React from 'react';
import axios from 'axios';
import { useState } from 'react';

const Show = () => {
    const [user, setUser] = useState([])
    const [err, setErr] = useState();

    const clickHandler = () => {
        axios.get("https://6305c64a697408f7edcacd27.mockapi.io/user")
            .then((response) => {
                console.log(response.data)
                setUser(response.data)
            })
            .catch((error) => {
                setErr(error.message)
            })

    }
    return (
        <>
            <div className="wrap-1">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="getData">
                                <h1 className='white'>Do you want to show Data?</h1>
                                <div><button onClick={clickHandler}>Yes</button></div>
                            </div>
                            <hr />
                        </div>
                    </div>
                    <div className="row">
                        {
                            user.map((row, i) => {
                                return (
                                    <div key={i} className="col-3 col-m-6 col-m-12" >
                                        <div className="getBox">
                                            <h2>Unique Id: {row.id}</h2>
                                            <img src={row.avatar} alt={row.name.name} />
                                            <p>Name: {row.name}</p>
                                            <p>Age: {row.age}</p>
                                            <p>Job: {row.job}</p>
                                            <p>Add: {row.address}</p>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        <div className="col-12">
                            <div className="error">
                                <h1>{err}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Show;